/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import type {
  CreateOrderResponse,
  CreateWebIdentificationForMembershipParams,
  CreateWebIdentificationForRegistrationParams,
  IdentityVerificationStart,
  IdentityVerificationStatusResponse,
  VerificationState
} from '../../schemas';

import { customFetchProtected } from '../../../custom-fetcher';

export type setStatusInterimResponse204 = {
  data: void
  status: 204
}

export type setStatusInterimResponseSuccess = (setStatusInterimResponse204) & {
  headers: Headers;
};
;

export type setStatusInterimResponse = (setStatusInterimResponseSuccess)

export const getSetStatusInterimUrl = () => {




  return `/api/v1/identity-verifications/interim-status`
}

export const setStatusInterim = async (verificationState: VerificationState, options?: RequestInit): Promise<setStatusInterimResponse> => {

  return customFetchProtected<setStatusInterimResponse>(getSetStatusInterimUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(verificationState)
  }
);}


export type createWebIdentificationForRegistrationResponse200 = {
  data: CreateOrderResponse
  status: 200
}

export type createWebIdentificationForRegistrationResponseSuccess = (createWebIdentificationForRegistrationResponse200) & {
  headers: Headers;
};
;

export type createWebIdentificationForRegistrationResponse = (createWebIdentificationForRegistrationResponseSuccess)

export const getCreateWebIdentificationForRegistrationUrl = (params?: CreateWebIdentificationForRegistrationParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/identity-verifications/registration?${stringifiedParams}` : `/api/v1/identity-verifications/registration`
}

/**
 * @summary Erstellt die Identitätsprüfung für die Registrierung
 */
export const createWebIdentificationForRegistration = async (params?: CreateWebIdentificationForRegistrationParams, options?: RequestInit): Promise<createWebIdentificationForRegistrationResponse> => {

  return customFetchProtected<createWebIdentificationForRegistrationResponse>(getCreateWebIdentificationForRegistrationUrl(params),
  {
    ...options,
    method: 'POST'


  }
);}


export type createWebIdentificationForMembershipResponse200 = {
  data: CreateOrderResponse
  status: 200
}

export type createWebIdentificationForMembershipResponseSuccess = (createWebIdentificationForMembershipResponse200) & {
  headers: Headers;
};
;

export type createWebIdentificationForMembershipResponse = (createWebIdentificationForMembershipResponseSuccess)

export const getCreateWebIdentificationForMembershipUrl = (membershipId: string,
    params?: CreateWebIdentificationForMembershipParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/identity-verifications/association-memberships/${membershipId}?${stringifiedParams}` : `/api/v1/identity-verifications/association-memberships/${membershipId}`
}

/**
 * @summary Erstellt die Identitätsprüfung für eine vorhandene Mitgliedschaft
 */
export const createWebIdentificationForMembership = async (membershipId: string,
    params?: CreateWebIdentificationForMembershipParams, options?: RequestInit): Promise<createWebIdentificationForMembershipResponse> => {

  return customFetchProtected<createWebIdentificationForMembershipResponse>(getCreateWebIdentificationForMembershipUrl(membershipId,params),
  {
    ...options,
    method: 'POST'


  }
);}


export type getStatusResponse200 = {
  data: IdentityVerificationStatusResponse
  status: 200
}

export type getStatusResponseSuccess = (getStatusResponse200) & {
  headers: Headers;
};
;

export type getStatusResponse = (getStatusResponseSuccess)

export const getGetStatusUrl = () => {




  return `/api/v1/identity-verifications/verification-status`
}

export const getStatus = async ( options?: RequestInit): Promise<getStatusResponse> => {

  return customFetchProtected<getStatusResponse>(getGetStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}


export type getStartDataForRegistrationResponse200 = {
  data: IdentityVerificationStart
  status: 200
}

export type getStartDataForRegistrationResponseSuccess = (getStartDataForRegistrationResponse200) & {
  headers: Headers;
};
;

export type getStartDataForRegistrationResponse = (getStartDataForRegistrationResponseSuccess)

export const getGetStartDataForRegistrationUrl = () => {




  return `/api/v1/identity-verifications/registration/start-data`
}

/**
 * @summary Liefert Startdaten für die Identitätsprüfung bei der Registrierung
 */
export const getStartDataForRegistration = async ( options?: RequestInit): Promise<getStartDataForRegistrationResponse> => {

  return customFetchProtected<getStartDataForRegistrationResponse>(getGetStartDataForRegistrationUrl(),
  {
    ...options,
    method: 'GET'


  }
);}


export type isIdentityVerificationEnabledResponse200 = {
  data: boolean
  status: 200
}

export type isIdentityVerificationEnabledResponseSuccess = (isIdentityVerificationEnabledResponse200) & {
  headers: Headers;
};
;

export type isIdentityVerificationEnabledResponse = (isIdentityVerificationEnabledResponseSuccess)

export const getIsIdentityVerificationEnabledUrl = () => {




  return `/api/v1/identity-verifications/enabled`
}

/**
 * @summary Gibt zurück, ob die Videolegitimation aktiviert ist
 */
export const isIdentityVerificationEnabled = async ( options?: RequestInit): Promise<isIdentityVerificationEnabledResponse> => {

  return customFetchProtected<isIdentityVerificationEnabledResponse>(getIsIdentityVerificationEnabledUrl(),
  {
    ...options,
    method: 'GET'


  }
);}


export type getStartDataForMembershipResponse200 = {
  data: IdentityVerificationStart
  status: 200
}

export type getStartDataForMembershipResponseSuccess = (getStartDataForMembershipResponse200) & {
  headers: Headers;
};
;

export type getStartDataForMembershipResponse = (getStartDataForMembershipResponseSuccess)

export const getGetStartDataForMembershipUrl = (membershipId: string,) => {




  return `/api/v1/identity-verifications/association-memberships/${membershipId}/start-data`
}

/**
 * @summary Liefert Startdaten für die Identitätsprüfung einer bestehenden Mitgliedschaft
 */
export const getStartDataForMembership = async (membershipId: string, options?: RequestInit): Promise<getStartDataForMembershipResponse> => {

  return customFetchProtected<getStartDataForMembershipResponse>(getGetStartDataForMembershipUrl(membershipId),
  {
    ...options,
    method: 'GET'


  }
);}


